import { FiltersParams } from 'types/params';
import { useCurrentSearchState } from './useCurrentSearchState';

export const useIsFilterApplied = ({
    filterType,
    code,
}: {
    filterType?: FiltersParams;
    code?: string;
}): boolean => {
    const { genres, instruments, sfxs, tags } = useCurrentSearchState();

    if (!filterType || !code) {
        return false;
    }

    switch (filterType) {
        case FiltersParams.genres:
            return !!genres?.includes(code);
        case FiltersParams.instruments:
            return !!instruments?.includes(code);
        case FiltersParams.sfxs:
            return !!sfxs?.includes(code);
        case FiltersParams.tags:
            return !!tags?.includes(code);
        default:
            return false;
    }
};
